module.exports = __webpack_public_path__ + "img/CM-EC-24-Acura-Playful.8a6f9fec.jpg";